import _ from 'underscore';
import type {
  AjaxHelperOptions,
  AjaxResponse,
  AlertCenter,
  RequestOptions,
  ServiceCallback,
} from './types';

export default class {
  ajaxSuccess: ServiceCallback;
  appendErrorSummary: ServiceCallback;
  ccuiAlertCenter?: AlertCenter;
  handleAjaxAuthFailure: ServiceCallback;
  constructor({
    ccuiAlertCenter,
    handleAjaxAuthFailure = _.noop,
    appendErrorSummary = _.noop,
    ajaxSuccess = _.noop,
  }: AjaxHelperOptions = {}) {
    this.ccuiAlertCenter = ccuiAlertCenter;
    this.handleAjaxAuthFailure = handleAjaxAuthFailure;
    this.appendErrorSummary = appendErrorSummary;
    this.ajaxSuccess = ajaxSuccess;
  }

  beforeSend = (options: RequestOptions) => _.wrap(options.beforeSend, (func: ServiceCallback | undefined, xhr: unknown) => {
    if (options.useAlertCenter && this.ccuiAlertCenter && options.alertId) {
      this.ccuiAlertCenter.dismiss(options.alertId);
    }

    if (_.isFunction(func)) {
      func(xhr);
    }
  });

  success = (options: RequestOptions) => _.wrap(options.onSuccess, (
    func: ServiceCallback | undefined,
    data: AjaxResponse | undefined,
    textStatus: unknown,
    xhr: unknown
  ) => {
    this.handleAjaxAuthFailure(data);
    if (options.useAlertCenter && options.alertId) {
      if (data && this.ccuiAlertCenter) {
        if (!_.isEmpty(data.Errors)) {
          this.ccuiAlertCenter.appendWarning(data.Errors, options.alertId);
        } else if (!_.isEmpty(data.Info)) {
          this.ccuiAlertCenter.appendInfo(data.Info, options.alertId);
        } else if (!_.isEmpty(data.Confirmation)) {
          this.ccuiAlertCenter.appendSuccess(data.Confirmation, options.alertId);
        }
      }
    } else if (data && !_.isEmpty(data.Errors)) {
      if (_.isFunction(options.onJsonError)) {
        options.onJsonError(data, textStatus, xhr);
      } else {
        this.appendErrorSummary(data.Errors);
      }
    } else if (data && !_.isEmpty(data.Alert)) {
      this.ajaxSuccess(data);
    }

    if (_.isFunction(func)) {
      func(data, textStatus, options.data, options.onsuccessEventData, xhr);
    }
  });

  error = (options: RequestOptions) => _.wrap(options.onAjaxError, (
    func: ServiceCallback | undefined,
    xhr: unknown,
    textStatus: unknown,
    errorThrown: unknown
  ) => {
    if (_.isFunction(func)) {
      func(xhr, textStatus, errorThrown);
    }
  });

  complete = (options: RequestOptions) => _.wrap(options.onAjaxComplete, (
    func: ServiceCallback | undefined,
    xhr: unknown,
    textStatus: unknown
  ) => {
    if (_.isFunction(func)) {
      func(xhr, textStatus);
    }
  });
}
